module.exports = __webpack_public_path__ + "img/H02058-81.2ec64050.jpg";